import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Menu from './pages/Menu';
import Booking from './pages/Booking';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Register from './pages/Register';
import Cart from './pages/Cart';
import MyOrders from './pages/MyOrders';
import Profile from './pages/Profile';
import OrderTracking from './pages/OrderTracking';
import OrderReceipt from './pages/OrderReceipt';
import ReviewPage from './pages/ReviewPage';
import ReviewsPage from './pages/ReviewsPage';
import NotFound from './pages/NotFound';

// Driver Portal
import DriverLayout from './components/Driver/DriverLayout';
import DriverLogin from './pages/Driver/DriverLogin';
import DriverForgotPassword from './pages/Driver/DriverForgotPassword';
import DriverDashboard from './pages/Driver/DriverDashboard';
import DriverOrders from './pages/Driver/DriverOrders';
import DriverOrderDetail from './pages/Driver/DriverOrderDetail';
import DriverHistory from './pages/Driver/DriverHistory';
import DriverProfile from './pages/Driver/DriverProfile';
import DriverNotifications from './pages/Driver/DriverNotifications';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/my-orders" element={<MyOrders />} />
          <Route path="/track-order/:orderId" element={<OrderTracking />} />
          <Route path="/receipt/:orderId" element={<OrderReceipt />} />
          <Route path="/review/:orderId" element={<ReviewPage />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/profile" element={<Profile />} />

          {/* Driver Portal Routes */}
          <Route path="/driver/login" element={<DriverLogin />} />
          <Route path="/driver/forgot-password" element={<DriverForgotPassword />} />
          <Route path="/driver" element={<DriverLayout />}>
            <Route path="dashboard" element={<DriverDashboard />} />
            <Route path="orders" element={<DriverOrders />} />
            <Route path="orders/:orderId" element={<DriverOrderDetail />} />
            <Route path="history" element={<DriverHistory />} />
            <Route path="profile" element={<DriverProfile />} />
            <Route path="notifications" element={<DriverNotifications />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
